import useIsAppWebView from "@hooks/useIsAppWebView";
import { ConfigurationSettings } from "@particles/configurationSettings/utils/types";
import ArticleContentAppWebView from "@routes/Article/ArticleContentAppWebView";
import { ArticlePageData } from "@routes/Article/utils/types";

import ArticlePageContent from "./ArticlePageContent";

type ArticleWrapperProps = {
  data: ArticlePageData;
} & Pick<ConfigurationSettings, "schema">;

const ArticleWrapper = ({
  data,
  schema,
}: ArticleWrapperProps): React.ReactElement => {
  const isWebView = useIsAppWebView();

  if (isWebView) return <ArticleContentAppWebView {...data} />;

  return <ArticlePageContent {...data} schema={schema} />;
};

export default ArticleWrapper;
